<template>
    <div :class="phoneClass || 'header-container'">
        <div class="header-wrapper">
            <div class="header-left">
                <div class="logo-band">
                    <img src="../../assets/logo.png" class="logo">
                    <!-- <span class="band-name">{{$t('title')}}</span> -->
                </div>
                <slot></slot>
            </div>
            <slot name="center"></slot>
            <div class="header-right">
                <el-select v-if="!phoneClass" v-model="lang" placeholder="请选择" @change="languageChange" class="lang-select">
                    <template slot="prefix">
                        <img src="../../assets/img/btn/icon-lang.png" class="icon-lang">
                    </template>
                    <el-option
                        v-for="lang in langList"
                        :key="lang.id"
                        :label="lang.name"
                        :value="lang.value">
                    </el-option>
                </el-select>
                <div class="user-avatar-wrapper" v-if="(user && username) && (!hiddenUser.includes($route.path))" >
                    <el-popover placement="bottom"
                                trigger="click"
                                :visible-arrow="false">
                        <span class="inner-span" @click="logout">账号登出</span>
                        <div class="user-avatar" slot="reference">
                            <img src="/avatar.png" class="avatar">
                            <span class="name">{{username}}</span>
                        </div>
                    </el-popover>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Core from 'core/core'
import {refresh} from "core/winSize"
export default {
    data() {
      return {
            phoneClass: '',
           langList: [
               {id:1,name:'中文',value: 'zh'},
               {id:2,name:'English',value: 'en'},
           ],
           lang: 'zh',
           username: '',
           user: '',
           hiddenUser: []
      };
    },
	created() {
		refresh(this,'phoneClass-phoneHeader');
		window.onresize = function(){
			setTimeout(function(){
				refresh(this,'phoneClass-phoneHeader');
			},10)
		};
	},
    mounted(){
        this.initUserInfo();
        this.getCurrentLang();
        this.getHiddenUserList();
    },
    methods:{
        getHiddenUserList() {
            this.hiddenUser = [];
            this.$router.options.routes.map(path => {
                path.hiddenUser ? this.hiddenUser.push(path.path): ''
            })
            // console.log(this.hiddenUser,this.$route.path)
        },
        initUserInfo(){
            let user = Core.Data.getUser();
            if(user) {
                this.user = user
                this.username = user.email || user.nickname || user.username || user.phone || "未知";
                this.avatar = user.avatar;
            }
        },
        getCurrentLang() {
            let lang = Core.Data.getLang();
            this.lang = lang
        },
        languageChange(val) {
            if(val === 'en') {
                i18n.locale = 'en';
                Core.Data.setLang('en');
                document.body.classList.remove(`lang-zh`)
                document.body.classList.add(`lang-en`)
                
            }else {
                i18n.locale = 'zh';
                Core.Data.setLang('zh');
                document.body.classList.remove(`lang-en`)
                document.body.classList.add(`lang-zh`)
            }
	        location.reload()
        },
        logout() {
            Core.Api.User.logout().then(()=>{
                this.$router.push('/login');
                Core.Data.clearAuthData();
            })
        }
    },
};
</script>
<style scoped lang="scss">
@import "../../assets/style/mixin";
.header-container {
    .header-wrapper {
        height: 90px;
        // min-width: 100vw;
        // background-color: #2F3A54;
        background: #0F58D6;

        @include flex-sb;
        .header-left {
            padding-left: 40px;
            display: inline-flex;
            height: 100%;
            align-items: center;
            .logo-band {
                // width: 272px;
                display: inline-block;
                // padding-right: 20px;
                vertical-align: middle;
                padding-right: 20px;
                .logo {
                    width: 111px;
                    height: 26px;
                    vertical-align: middle;
                }
                .band-name {
                    font-size: 20px;
                    color: #FFFFFF;
                    line-height: 26px;
                    margin-left: 10px;
                    font-weight: 500;
                    vertical-align: middle;
                }
            }
        }
        .header-right {

            .icon-lang {
                width: 20px;
                height: 20px;
            }
            .lang-select {
                margin-right: 20px;
                vertical-align: middle;
            }
            .user-avatar-wrapper {
                padding-left: 20px;
                display: inline-block;
                padding-right: 40px;
                border-left: 1px solid rgba($color: #000000, $alpha: .3);
                .user-avatar {
                    cursor: pointer;
                    .avatar {
                        width: 34px;
                        height: 34px;
                        vertical-align: middle;
                    }
                    .name {
                        font-size: 14px;
                        color: #FFFFFF;
                        vertical-align: middle;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
    .header-container {
        .lang-select {
            border-radius: 20px;
            .el-input__inner {
                // min-width: 88px;
                width: auto;
                max-width: 118px;
                border-radius: 20px;
                width: auto;
                background-color: rgba($color: #000000, $alpha: .1);
                color: #fff;
                height: 36px;
                padding-left: 34px !important;
                border-color: rgba($color: #FFFFFF, $alpha: .1)
            }
            .el-input__prefix {
                display: inline-flex;
                left: 8px;
                align-items: center;
            }
            .el-select-dropdown.el-popper {
                border-radius: 20px;
            }
        }
    }

    .phoneClass-phoneHeader {
        .header-wrapper {
            background: #0F58D6;
            min-height: 60px;
            display: flex;
            align-items: center!important;
            justify-content: space-between;
            .header-left {
                display: inline-flex;
                /*height: 100%;*/
                position: relative;
                align-items: center;
                width: 30%;
                margin-left: 10px;
                //margin-top: 10px;
                .logo-band {
                    img {
                        vertical-align: -webkit-baseline-middle;
                        min-width: 60px;
                        min-height: 25px;
                        height: 25px;
                        /*height: 30px;*/
                    }
                }
                .slot-content {
                    border-left: 1px solid rgba(0, 0, 0, 0.3);
                    min-width: 100px;
                    color: #99BEFF;
                    font-size: 20px;
                    margin-left: 10px;
                    font-weight: 500;
                }
            }
            .header-right {
                text-align: right;
                position: relative;
                width: 70%;
                .el-select {
                    width: 100px;
                    .el-input {
                        .el-input__inner {
                            font-size: 10px;
                            height: 25px;
                            background-color: rgba(0, 0, 0, 0.1);
                            border-radius: 20px;
                            color: white;
                            padding-left: 34px;
                        }
                        .el-input__prefix{
                            top: 5px;
                            margin-left: 5px;
                            img {
                                width: 15px;
                                height: 15px;
                            }
                        }
                        .el-input__suffix {
                            color: #C0C4CC;
                        }
                    }
                }
                .user-avatar-wrapper {
                    min-width: 100px;
                    padding-left: 10px;
                    margin-left: 10px;
                    border-left: 1px solid rgba(0, 0, 0, 0.3);
                    text-align: center;
                    .user-avatar {
                        .avatar {
                            vertical-align: bottom;

                        }
                        .name {
                            font-size: 10px;
                        }
                    }
                }
            }
        }
    }

    .inner-span{
        display: inline-block;
        width: 100px;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
        padding: 8px 0;
    }
</style>